//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import upsertReportSpecies from '~/graphql/mutations/upsertReportSpecies';
import reportSpecies from '~/graphql/queries/reportSpecies';

export default {
  props: {
    currentSpecies: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    species: [],
    allFilled: false,
  }),
  methods: {
    addSpecies(item) {
      if (!this.species.filter(s => s.uuid === item.uuid).length && !this.currentSpecies.filter(s => s.species.uuid === item.uuid).length) {
        this.species.unshift(item);
      } else {
        this.$toast.error('Deze soort bestaat al in deze rapportage');
      }
      this.checkIfAllFilled();
    },
    closeBlocks(exception) {
      this.$refs['location-species'].forEach((item, key) => {
        if (exception !== key) {
          item.closeBlock();
        }
      });
    },
    removeSpecies(index) {
      if (this.species[index].reportSpecies && this.species[index].reportSpecies.uuid) {
        this.deleteSpecies(index);
      } else {
        this.species.splice(index, 1);
      }
    },
    setSpeciesData(index, data) {
      this.checkIfAllFilled();
      if (!data) {
        return;
      }
      if (!this.species[index].reportSpecies) {
        this.species[index].reportSpecies = {};
      }
      this.species[index].reportSpecies.abundance = data.abundance;
      this.species[index].reportSpecies.certainty = data.certainty;
      this.species[index].reportSpecies.modified = true;
    },
    checkIfAllFilled() {
      let allFilled = true;
      this.species.forEach((species) => {
        if (!species.reportSpecies || !species.reportSpecies.abundance || !species.reportSpecies.certainty) {
          allFilled = false;
        }
      });
      this.$nuxt.$emit('global:disable-next', !allFilled);
      this.$nuxt.$emit('global:disable-previous', !allFilled);
      this.allFilled = allFilled;
    },
    save() {
      if (!this.allFilled) {
        this.$toast.error('Niet alle soorten zijn volledig ingevuld.');
        return;
      }
      this.species.forEach((species, index) => {
        if (species.reportSpecies && species.reportSpecies.abundance && species.reportSpecies.certainty && species.reportSpecies.modified) {
          this.uploadSpecies(species, index === (this.species.length - 1));
        }
      });
    },
    async uploadSpecies(species, last) {
      species.reportSpecies.modified = false;
      try {
        await this.$apollo.mutate({
          mutation: upsertReportSpecies,
          variables: {
            report: this.$route.params.uuid,
            species: species.uuid,
            abundance: species.reportSpecies.abundance,
            certainty: species.reportSpecies.certainty,
            ...(species.reportSpecies.uuid ? {uuid: species.reportSpecies.uuid} : {}),
          },
          refetchQueries: {
            query: reportSpecies,
            variables: {
              uuid: this.$route.params.uuid,
            },
          },
        }).then(({data}) => {
          species.reportSpecies.uuid = data.upsertReportSpecies.uuid;
          this.$emit('add', data.upsertReportSpecies);
          if (last) {
            this.$toast.success('Soorten zijn succesvol toegevoegd.');
            this.$emit('close');
            this.species = [];
          }
        });
      } catch (e) {
        this.$toast.error(e);
      }
    },
  },
};
